import React, { useState, useRef } from 'react';
import { useHistory } from 'react-router';

import Tooltip from 'components/Tooltips/Tooltip';
import useCompanyConfiguration from 'hooks/useCompanyConfiguration';
import useStoreTranslation from 'hooks/useStoreTranslation';

import DesktopProfileMenu from '../DesktopProfileMenu';
import { Container, IconProfile, IconHelp, Icon } from './styles';

interface Props {
  name: string;
  email: string;
  companyName: string;
  companyCountry: string;
  companyCountryCode: string;
  hasCompanyBranches: boolean;
  branchCompanyLogged: boolean;
}

const RequesterProfile = ({
  name,
  email,
  companyName,
  companyCountry,
  companyCountryCode,
  hasCompanyBranches,
  branchCompanyLogged,
}: Props) => {
  const { t } = useStoreTranslation();
  const history = useHistory();
  const initialsRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  const handleMenuToggle = () => setOpen(!open);
  const companyConfiguration = useCompanyConfiguration();

  const handleCountrySelection = () => {
    history.push('/corporate/user-country-selection');
  };

  const handleCountryFlag = (branchCompany: string) => {
    switch (branchCompany) {
      case 'BR': {
        return 'corporate/images/flags/BR.png';
      }
      case 'CO': {
        return 'corporate/images/flags/CO.png';
      }
      case 'AR': {
        return 'corporate/images/flags/AR.png';
      }
      case 'UY': {
        return 'corporate/images/flags/UY.png';
      }
      case 'MX': {
        return 'corporate/images/flags/MX.png';
      }
    }

    return 'corporate/images/flags/CO.png';
  };

  const getWhatsAppWidget = () =>
    `<a href="https://api.whatsapp.com/send?phone=${companyConfiguration?.menuView?.useWhatsappSupport}&text=${companyConfiguration?.menuView?.useWhatsappSupportMessage}" target="_blank" style="height: 60px;  cursor: pointer;  display: flex;  align-items: center;  justify-content: center;  flex-direction: column;  padding: 5px 12px; margin-bottom: 7px;"><img src="/corporate/images/whatsapp-active.svg" alt="WhatsApp" style="width: 26px; height: 26px;"/></a>`;

  const renderChat = () =>
    companyConfiguration?.menuView?.showWhatsappAllPages &&
    companyConfiguration?.menuView?.useWhatsappSupport !== '' &&
    companyConfiguration?.menuView?.useWhatsappSupport !== null &&
    companyConfiguration?.menuView?.useWhatsappSupport !== undefined
      ? getWhatsAppWidget()
      : '';

  return (
    <Container>
      {companyConfiguration?.imageLogoBytes && (
        <Tooltip event="hover" content={companyConfiguration?.companyName}>
          <Icon.Flag>{<img alt="" src={companyConfiguration.imageLogoBytes} />}</Icon.Flag>
        </Tooltip>
      )}
      {!companyConfiguration?.imageLogoBytes && companyConfiguration?.imageLogo && (
        <Tooltip event="hover" content={companyConfiguration?.companyName}>
          <Icon.Flag>{<img alt="" src={companyConfiguration.imageLogo} />}</Icon.Flag>
        </Tooltip>
      )}

      <Icon onClick={handleMenuToggle}>
        <IconProfile />
        <Icon.Label>{t('dashboard.menu.profile')}</Icon.Label>
      </Icon>
      <DesktopProfileMenu
        open={open}
        onToggle={handleMenuToggle}
        initialsRef={initialsRef}
        name={name}
        email={email}
        companyName={companyName}
        countryName={companyCountry}
        branchCompanyLogged={branchCompanyLogged}
        hasCompanyBranches={hasCompanyBranches}
        countryCode={companyCountryCode}
      />
      <Icon onClick={() => history.push('/corporate/customerSupport')}>
        <IconHelp />
        <Icon.Label>{t('dashboard.menu.help')}</Icon.Label>
      </Icon>
      <div dangerouslySetInnerHTML={{ __html: renderChat() }}></div>
    </Container>
  );
};

export default RequesterProfile;
